var _path, _path2, _mask, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24076 17.043H3.46484C3.08534 17.043 2.77734 16.735 2.77734 16.3555C2.77734 15.976 3.08534 15.668 3.46484 15.668H9.24076C9.62026 15.668 9.92826 15.976 9.92826 16.3555C9.92826 16.735 9.62026 17.043 9.24076 17.043Z",
    fill: "#D9DEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5914 8.15625H11.8164C11.4369 8.15625 11.1289 7.84825 11.1289 7.46875C11.1289 7.08925 11.4369 6.78125 11.8164 6.78125H17.5914C17.9709 6.78125 18.2789 7.08925 18.2789 7.46875C18.2789 7.84825 17.9709 8.15625 17.5914 8.15625Z",
    fill: "#D9DEF4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 7,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 4.58203H8.45698V10.2577H2.75V4.58203Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60358 5.95703C4.78867 5.95703 4.125 6.61337 4.125 7.42095C4.125 8.22762 4.78867 8.88303 5.60358 8.88303C6.41942 8.88303 7.08217 8.22762 7.08217 7.42095C7.08217 6.61337 6.41942 5.95703 5.60358 5.95703ZM5.60358 10.258C4.03058 10.258 2.75 8.9857 2.75 7.42095C2.75 5.8562 4.03058 4.58203 5.60358 4.58203C7.1775 4.58203 8.45717 5.8562 8.45717 7.42095C8.45717 8.9857 7.1775 10.258 5.60358 10.258Z",
    fill: "#D9DEF4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9404 14.8555C15.1246 14.8555 14.4609 15.5118 14.4609 16.3185C14.4609 17.1261 15.1246 17.7815 15.9404 17.7815C16.7554 17.7815 17.4181 17.1261 17.4181 16.3185C17.4181 15.5118 16.7554 14.8555 15.9404 14.8555ZM15.9404 19.1565C14.3665 19.1565 13.0859 17.8832 13.0859 16.3185C13.0859 14.7537 14.3665 13.4805 15.9404 13.4805C17.5134 13.4805 18.7931 14.7537 18.7931 16.3185C18.7931 17.8832 17.5134 19.1565 15.9404 19.1565Z",
    fill: "#D9DEF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.0c0fc000.svg";
export { ForwardRef as ReactComponent };